var _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgSalle = function SvgSalle(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    x: "0px",
    y: "0px",
    viewBox: "-457 267.3 44.6 27.7",
    style: {
      enableBackground: "new -457 267.3 44.6 27.7"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: -446.7,
    cy: 285.6,
    r: 3.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-444.5,289.5h-0.4c-0.5,0.3-1.2,0.4-1.8,0.4c-0.6,0-1.2-0.1-1.8-0.4h-0.4c-1.8,0-3.3,1.5-3.3,3.3v1 c0,0.7,0.5,1.2,1.2,1.2h8.7c0.7,0,1.2-0.5,1.2-1.2v-1C-441.2,291-442.7,289.5-444.5,289.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-432.2,289.5h-0.4c-0.5,0.3-1.2,0.4-1.8,0.4s-1.2-0.1-1.8-0.4h-0.4c-1.8,0-3.3,1.5-3.3,3.3v1 c0,0.7,0.5,1.2,1.2,1.2h8.7c0.7,0,1.2-0.5,1.2-1.2v-1C-428.9,291-430.4,289.5-432.2,289.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -434.4,
    cy: 285.6,
    r: 3.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -422.2,
    cy: 285.6,
    r: 3.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-420,289.5h-0.4c-0.5,0.3-1.2,0.4-1.8,0.4c-0.6,0-1.2-0.1-1.8-0.4h-0.4c-1.8,0-3.3,1.5-3.3,3.3v1 c0,0.7,0.5,1.2,1.2,1.2h8.7c0.7,0,1.2-0.5,1.2-1.2v-1C-416.7,291-418.1,289.5-420,289.5z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "-434.7,267.3 -457,276.2 -455.5,279.9 -434.7,271.6 -413.9,279.9 -412.4,276.2  "
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSalle, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/salle.2d90261e.svg";
export { ForwardRef as ReactComponent };